import Immutable from 'immutable';
import { LIVE_INIT, LIVE_MATCH_INIT } from '../../sagas/actions';
import sportsReducer from './sportsReducer';
import leaguesReducer from './leaguesReducer';
import matchesReducer from './matchesReducer';
import scoresReducer from './scoresReducer';
import outcomesReducer from './outcomesReducer';
import outcomesHeadersReducer from './outcomesHeadersReducer';
import ratesReducer from './ratesReducer';
import stateReducer from './stateReducer';
import versionReducer from './versionReducer';
import selectedMatchReducer from './selectedMatchReducer';
import commonStateReducer from './commonStateReducer';
import * as LineActions from '../../actions/lines';
import * as PopularActions from '../../actions/popular';
import * as RepositoryState from '../../constants/RepositoryState';
import * as MatchResultsAction from '../../actions/matchResults';
import { CLEAR_LIVE_MATCH } from '../../actions/live';
import { CHANGE_LOCALE } from '../../actions/locale';
var initialState = Immutable.fromJS({
    sports: {},
    leagues: {},
    matches: {},
    matchGroups: {},
    outcomes: {},
    rates: {},
    scores: {},
    valid: true,
    state: RepositoryState.NOT_INITED,
    version: 0,
    selectedMatchId: null,
    fetching: false,
    isMatchNotFound: false,
});
export default function entitiesReducer(entities, action, section) {
    if (entities === undefined) {
        return initialState;
    }
    switch (action.type) {
        case MatchResultsAction.FETCH_MATCH_RESULTS:
        case LIVE_INIT.REQUEST:
        case LIVE_MATCH_INIT.REQUEST:
        case PopularActions.FETCH_POPULAR_MATCHES:
        case LineActions.FETCH_LINE_HEADERS:
        case LineActions.FETCH_SPORT_LINE_HEADERS:
        case LineActions.FETCH_LEAGUE_LINE_HEADERS:
        case LineActions.FETCH_FULL_LINE:
            entities = entities.update('fetching', function () { return true; });
            // entities = entities.update('isMatchNotFound', () => false);
            break;
        case MatchResultsAction.SUCCESS_FETCH_MATCH_RESULTS:
        case LIVE_INIT.SUCCESS:
        case LIVE_MATCH_INIT.SUCCESS:
        case PopularActions.SUCCESS_FETCH_POPULAR_MATCHES:
        case LineActions.SUCCESS_FETCH_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_SPORT_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_LEAGUE_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_FULL_LINE:
        case CLEAR_LIVE_MATCH:
        case CHANGE_LOCALE:
            entities = entities.update('fetching', function () { return false; });
            entities = entities.update('isMatchNotFound', function () { return false; });
            break;
        case LineActions.FAILURE_FETCH_FULL_LINE:
            entities = entities.update('fetching', function () { return false; });
            entities = entities.update('isMatchNotFound', function () { return true; });
            break;
        case LIVE_MATCH_INIT.FAILURE:
            entities = entities.update('fetching', function () { return false; });
            entities = entities.update('isMatchNotFound', function () { return true; });
    }
    if (action.section === section) {
        try {
            entities = entities.update('sports', function (s) { return sportsReducer(s, action); });
            entities = entities.update('leagues', function (l) { return leaguesReducer(l, action); });
            entities = entities.update('matches', function (m) { return matchesReducer(m, action); });
            entities = entities.update('scores', function (s) { return scoresReducer(s, action); });
            entities = entities.update('rates', function (r) { return ratesReducer(r, action); });
            entities = entities.update('outcomes', function (o) { return outcomesReducer(o, action); });
            entities = entities.update('outcomes', function (o) {
                return outcomesHeadersReducer(action, o, entities.get('matches'), entities.get('rates'));
            });
            entities = entities.update('version', function (v) { return versionReducer(v, action); });
            entities = entities.update('selectedMatchId', function (matchId) {
                return selectedMatchReducer(matchId, entities.get('sports'), entities.get('leagues'), entities.get('matches'), action);
            });
            entities = entities.update('state', function (s) { return stateReducer(s, action); });
            entities = entities.update('valid', function () { return true; });
        }
        catch (err) {
            //if (process.env.NODE_ENV !== 'production') {
            console.warn('Exception at entitiesReducer');
            console.warn(err);
            //}
            return initialState.set('valid', false);
        }
    }
    else {
        entities = entities.update('state', function (s) { return commonStateReducer(s, action); });
    }
    return entities;
}



// WEBPACK FOOTER //
// ./src/reducers/entities/entitiesReducer.js